var render = function render(){var _vm=this,_c=_vm._self._c;return _c('local-storage-sync',{attrs:{"storage-key":_vm.storageKey,"value":_vm.selected,"as-string":""},on:{"input":_vm.setSelected}},[_c('gl-collapsible-listbox',{attrs:{"items":_vm.listboxItems},on:{"select":_vm.setSelected},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }